export function mapWorkflowActionToApi(action) {
  const normalizedAction = String(action || '').trim().toUpperCase();

  if (normalizedAction === 'APPROVE') return 'Approved';
  if (normalizedAction === 'REJECT') return 'Rejected';
  if (normalizedAction === 'DISABLE') return 'Disabled';

  throw new Error(`Unsupported workflow action: ${action}`);
}
